module.exports = __webpack_public_path__ + "images/nissan_small21cef3b48c38d8263d5ae18639baa184.png";